import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { PRODUCT_CONFIG } from "../config/productConfig.js";
import { useTranslation } from "../i18n/useTranslation.js";

const FinalCall = observer(() => {
  const { t } = useTranslation();
  return (
    <section className="landing-final-visual">
      <img src="/assets/landing/invitation.webp" alt="" loading="lazy" />
      <div className="landing-final-content">
        <p className="landing-eyebrow">{t("landing.alpha.eyebrow")}</p>
        <h2>{t("landing.alpha.title")}</h2>
        <p>{t("landing.alpha.body")}</p>
        <div className="landing-actions">
          <a className="landing-primary-action" href={PRODUCT_CONFIG.loginPath}>{t("landing.alpha.enter")}</a>
          <Link className="landing-secondary-action" to="/news/closed-alpha-launch">{t("landing.alpha.read")}</Link>
        </div>
      </div>
    </section>
  );
});

export default FinalCall;
